import React from 'react';
import styled from 'styled-components';
import {Button} from 'components/antd';
import {useFetchAiAssistMutation, AccountAiAssist} from 'api';
import EmptyState from './EmptyState';
import Content from './Content';

interface Props {
  prospectPoolUuid: string;
  aiAssist?: AccountAiAssist | null;
}

export default ({prospectPoolUuid, aiAssist}: Props) => {
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [fetchAiAssist, {loading}] = useFetchAiAssistMutation({
    variables: {uuid: prospectPoolUuid},
    refetchQueries: ['prospectPool'],
    onCompleted: (data) => {
      setErrorMessage(data?.fetchAiAssist?.error);
    },
  });

  return (
    <Container>
      <Header>
        <Title>企業情報　AIアシスト</Title>
      </Header>
      <FetchButton
        type="primary"
        loading={loading}
        onClick={() => fetchAiAssist()}>
        AIで最新情報を取得
      </FetchButton>
      {errorMessage && (
        <p className="text-center p-2 text-red-500 text-bold">{errorMessage}</p>
      )}
      <ContentArea>
        {aiAssist?.content ? (
          <Content content={aiAssist.content} fetchedAt={aiAssist.fetchedAt} />
        ) : (
          <EmptyState />
        )}
      </ContentArea>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 16px 0;
  border-bottom: 1px solid var(--border-color);
`;

const Title = styled.h3`
  font-weight: bold;
  font-size: 14px;
  line-height: 1em;
  letter-spacing: 0.0125em;
  color: var(--text-color-2);
  margin: 0;
`;

const FetchButton = styled(Button)`
  &&& {
    margin: 16px auto 0;
    border-radius: 100px;
    font-weight: bold;
    font-size: 12px;
    padding: 12px 16px;
    height: auto;
  }
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  margin-top: 16px;
`;
